import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import "../pages/Rating.css";

const Rating = ({ customerDetails }) => {
  const [selectedRating, setSelectedRating] = useState(null);
  const [otp, setOtp] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const [showCommentSection, setShowCommentSection] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const viewKey = searchParams.get("view_key");
  const { vehicleNumber = "", srNumber = "" } = location?.state || {};

  const ratingImages = [
    `${process.env.PUBLIC_URL}/images/rate1.jpg`,
    `${process.env.PUBLIC_URL}/images/rate2.jpg`,
    `${process.env.PUBLIC_URL}/images/rate3.jpg`,
    `${process.env.PUBLIC_URL}/images/rate4.jpg`,
    `${process.env.PUBLIC_URL}/images/rate5.jpg`,
  ];

  const handleSubmitOTP = async () => {
    try {
      const response = await axiosInstance.post(
        "/pifir/verify/",
        {
          otp_value: otp,
          view_key: viewKey,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      setPopupMessage(response.data.msg);
      setShowPopup(true);
      setIsVerified(response.data.status);
      setError(
        response.data.status ? null : "Invalid OTP or View Key mismatch."
      );
    } catch (error) {
      console.error("Error:", error);
      setPopupMessage("Something went wrong.");
      setShowPopup(true);
      setIsVerified(false);
    }
  };

  const handleResendOTP = (e) => {
    e.preventDefault();
    navigate("/events", { state: { vehicleNumber, srNumber } });
  };

  const handleRatingClick = async (index) => {
    if (!isVerified) {
      setPopupMessage("Please verify OTP before submitting feedback.");
      setShowPopup(true);
      return;
    }

    const selectedValue = index + 1;
    setSelectedRating(selectedValue);

    if (selectedValue >= 4) {
      setShowCommentSection(true);
      return;
    }

    setShowCommentSection(false);
    setComment(""); 
    setLoading(true);
    

    await handleSubmitFeedback(index + 1); 
  };

  const handleSubmitFeedback = async (ratingvalue) => {
    if (!comment.trim() && ratingvalue >= 4) {
      setPopupMessage("Please enter a comment.");
      setShowPopup(true);
      return;
    }

    if (ratingvalue > 0 && ratingvalue <= 3) {
      setComment(""); 
    }

    setCommentLoading(true);
    setLoading(true);

    try {
      await axiosInstance.post(
        `/pifir/fdbk/?view_key=${viewKey}`,
        {
          feedback: ratingvalue.toString(),
          comment: comment || "",
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      setPopupMessage("Thank you for your feedback!");
      setFeedbackSubmitted(true);
      setShowCommentSection(false)
      setTimeout(() => {
        navigate("/services")
      }, 3000);
    } catch (error) {
      console.error("Error submitting comment:", error);
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    } finally {
      setCommentLoading(false);
      setLoading(false);
    }
  };

  return (
    <div className={`rating-container container ${showCommentSection ? "height-1000" : ""}`}>
      {feedbackSubmitted ? (
        <h2>Feedback submitted successfully!</h2>
      ) : (
        <>
          <h4>
            <button
              className="back-button"
              onClick={() => navigate(-1)}
              disabled={feedbackSubmitted}
            >
              &larr; Back
            </button>
          </h4>

          {/* OTP Section */}
          <div className="otp-section">
            <span>Reg. Number : {vehicleNumber}</span>
            <span>Sr. Number : {srNumber}</span>
            <span className="otp-text">
              Please Enter OTP Sent to Your Registered Mobile Number.
            </span>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              className="otp-input"
              disabled={feedbackSubmitted}
            />
            <button
              className="submit-button"
              onClick={handleSubmitOTP}
              disabled={feedbackSubmitted}
            >
              Submit
            </button>
            <button
              className="resend-button"
              disabled={feedbackSubmitted}
              onClick={handleResendOTP}
            >
              Resend OTP
            </button>
            {error && <p className="error-text">{error}</p>}
          </div>

          {/* Rating Section */}
          <div className={`rating-section ${isVerified ? "active" : ""}`}>
            <span className="rating-text">How was your experience?</span>
            <div className="rating-section-container">
              {ratingImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Rating ${index + 1}`}
                  onClick={() => handleRatingClick(index)}
                  className={`rating-image-otp ${
                    selectedRating === index + 1 ? "active" : ""
                  }`}
                />
              ))}
            </div>
          </div>

          {loading && <p>Submitting Feedback...</p>}

          {showCommentSection && (
            <div className="comment-section" style={{ marginTop: "50px" }}>
              <h3>Please Enter Your Comment</h3>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter your comment"
                rows={4} // Adjust rows as needed
                cols={50} // Optional: Adjust width
              />

              <button
                className="submit-button"
                onClick={()=>handleSubmitFeedback(selectedRating)}
                style={{ marginTop: "30px" }}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          )}
        </>
      )}

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rating;
